import {
  CLEAR,
  LOGIN,
  REGISTER,
  LOGOUT,
  UPDATE_USER,
  UPDATE_USER_PROFILE_IMG,
  RECOVER,
} from "../actions/types";

const initialState = {
  register: null,
  login: null,
  update: null,
  user: null,
  updateImage: null,
};

export default function authReducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case LOGIN:
      if (payload.code == 200) {
        var user = payload["user"];
        delete payload["user"];
        localStorage.setItem("user_info", JSON.stringify(user));
      }
      return {
        ...state,
        user,
        login: payload,
      };
    case RECOVER:
      return {
        ...state,
        recover: payload,
      };
    case REGISTER:
      return {
        ...state,
        register: payload,
      };
    case UPDATE_USER:
      if (payload.code == 200) {
        let user = JSON.parse(localStorage.getItem("user_info"));
        user.email = payload.user.email;
        user.full_name = payload.user.full_name;
        localStorage.setItem("user_info", JSON.stringify(user));
      }
      return {
        ...state,
        update: payload,
      };
    case UPDATE_USER_PROFILE_IMG:
      if (payload.code == 200) {
        let user = JSON.parse(localStorage.getItem("user_info"));
        user.profile_img = payload.user.profile_img;
        localStorage.setItem("user_info", JSON.stringify(user));
      }
      return {
        ...state,
        updateImage: payload,
      };

    case LOGOUT:
      localStorage.removeItem("user_info");
      return {
        ...state,
      };
    case CLEAR:
      if (payload in state) {
        return {
          ...state,
          [payload]: null,
        };
      }
    case "GET_USER":
      return {
        ...state,
        user: action.user,
      };
    default:
      return {
        ...state,
      };
  }
}
